<template>
  <div
    class="labelStyle"
    :class="{
      athena_palette: theme == 'athena',
      swiper_label: type == 'card' && palette_config.show_num == 0,
      commmandProductPopup: isPopup
    }"
  >
    <div
      v-for="subitem in palette_attr_item.value.slice(0,type=='detail'||!palette_config.show_num?palette_attr_item.value.length:palette_config.show_num)"
      :key="subitem"
      class="labelItem"
      :class="{
        active: variant_attrs[index].value == subitem,
      }"
    >
      <input
        v-model="variant_attrs[index].value"
        :id="
          model_name+palette_attr_item.name +
          index +
          subitem +
          (palette_attr_item.config[subitem] &&
            palette_attr_item.config[subitem]['variant_id'])
        "
        :value="subitem"
        type="radio"
      />
      <label
        @mouseenter="mouse_enter && mouse_seled(index, subitem)"
        @click="$emit('change', subitem)"
        v-if="verify_config(index,subitem)"
        class="secondary_title"
        :class="[
           palette_config.show_style||'round',
          {
            'main_button_boder ': variant_attrs[index].value == subitem,
            'main_button ':
              theme !== 'athena' && variant_attrs[index].value == subitem,
          },
        ]"
        :style="{
          background:
            palette_attr_item.palette_type == 'auto_block' &&
            test_color(subitem)
              ? 'unset'
              : '',
        }"
        :for="
          model_name+palette_attr_item.name +
          index +
          subitem +
          (palette_attr_item.config[subitem] &&
            palette_attr_item.config[subitem]['variant_id'])
        "
      >
        <!-- 手动设置 -->
        <div
          v-if="palette_attr_item.palette_type == 'manual'"
          class="palette-label__img"
          :style="{
            background:
              palette_attr_item.config[subitem].show_type == 'show_image'
                ? `url(${palette_attr_item.config[subitem].image_src}) 0% 0% / cover`
                : palette_attr_item.config[subitem].color_code
                    .toString()
                    .toLowerCase(),
          }"
        ></div>
        
        <!-- 自动图片 -->
        <div
          v-else-if="palette_attr_item.palette_type == 'auto_image'"
          class="palette-label__img"
          style="background-size: cover"
          :style="{
            background: `url(${
              palette_attr_item.config[subitem] &&
              palette_attr_item.config[subitem].default_image_src
            }) 0% 0% / cover`,
          }"
        ></div>

        <!-- 自动颜色 -->
        <div
          class="palette-label__img"
          v-else-if="palette_attr_item.palette_type == 'auto_block'"
          style="background-size: cover"
          :style="{ background: subitem.toString().toLowerCase() }"
        ></div>
        <template v-else>
          <div style="text-align: center; line-height: 28px; margin-top: 0">
            {{ subitem }}
          </div>
        </template>
      </label>
      <template v-else>
        <label
          v-if="type == 'detail'"
          @click="$emit('change', subitem)"
          class="secondary_title palette-detail"
          :class="[
            theme == 'vogue' && variant_attrs[index].value == subitem
              ? 'main_button'
              : '',
            themeStyleRadius == 'circle' ? 'button-radius' : ''
          ]"
          :for="
            model_name+palette_attr_item.name +
            index +
            subitem +
            (palette_attr_item.config[subitem] &&
              palette_attr_item.config[subitem]['variant_id'])
          "
        >
          {{ subitem }}
        </label>
      </template>
    </div>
    <a
      v-if="
        type == 'card' &&
        palette_attr_item.palette_type != '' &&
        palette_attr_item.value.length > (palette_config.show_num||9999)
      "
      :href="url"
    >
      <div class="labelItem2">
        <label class="labelItemEllipsis"> <div class="d-flex align-items-center justify-content-center"> ... </div> </label>
      </div>
    </a>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: [
    "palette_config",
    "type",
    "palette_attr_item",
    "variant_attrs",
    "theme",
    "url",
    "index",
    "mouse_enter",
    "model_name",
    "isPopup",
    "verify_config",//验证该属性是否有调色板配置
    "test_color",//验证是否有该颜色
  ],
  emits: ['change'],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    })
  },
  methods: {
    mouse_seled(index, value) {
      this.variant_attrs[index].value = value;
    },
  },
  mounted() {
    this.$el.style.setProperty("--el-width", this.$el.offsetWidth + "px");
    this.$(window).resize(
      this.debounce(() => {
        this.$(this.$el).css("--el-width", this.$el.offsetWidth + "px");
      }, 200)
    );
  },
};
</script>
<style scoped lang='scss'>
.labelStyle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 1;
  .labelItem,
  .labelItem2 {
    display: inline-block;
    vertical-align: top;
    label {
      margin: 0;
      cursor: pointer;
      font-weight: 600;
      font-style: normal;
      letter-spacing: 0.1em;
      // text-transform: uppercase;
      line-height: 1;
      padding: 9px 11px;
      // margin: 3px 10px 7px 0px;
      margin-right: 7.5px;
      margin-bottom: 5px;
      font-size: 0.86667em;
      font-style: normal;
      background-color: #fff;
      border: 1px solid #d2d2d2;
      color: #222323;
      cursor: pointer;
    }
    input {
      clip: rect(0, 0, 0, 0);
      overflow: hidden;
      position: absolute;
      height: 1px;
      width: 1px;
      // &:focus + label,
      // &:active + label {
      //   background-color: #f2f2f2;
      // }
    }
  }
  .labelItem2:hover {
    label {
      border: 1px solid #d2d2d2;
    }
  }
  .round,
  .fillet,
  .right_angle,
  .labelItemEllipsis {
    div {
      min-width: 40px;
      min-height: 40px;
    }
    padding: 1px !important;
  }
  .round {
    border-radius: 50% !important;
    div {
      border-radius: 50%;
    }
  }
  .fillet {
    border-radius: 8px !important;
    div {
      border-radius: 8px;
    }
  }
  .active {
    label {
      background-color: var(--main-btn-bg);
      border-color: var(--main-btn-bg);
      color: var(--main-btn-tx);
    }
  }
}
.swiper_label {
  white-space: nowrap;
  display: block;
  .labelItem,
  .labelItem2 {
    label {
      // margin:0 3px !important;
      margin-bottom: 0 !important;
    }
    // .round,
    // .fillet,
    // .right_angle {
    //   div {
    //     // width: calc(var(--el-width) / 4.5 - 11px);
    //     // height: calc(var(--el-width) / 4.5 - 11px);
    //     max-width: 64px;
    //     max-height: 64px;
    //     min-width: 40px;
    //     min-height: 40px;
    //   }
    // }
  }
}
.athena_palette {
  .round {
    div {
      min-width: 44px;
      min-height: 44px;
    }
  }
  .round {
    background-color: transparent !important;
    padding: 2px !important;
  }
  .active {
    .round {
      border-width: 1px;
      padding: 2px !important;
    }
  }
}
.commmandProductPopup {
  .labelItem {
    label {
      width: 46px;
      height: 47px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 15px 4px;
    }
  }

}
@media screen and (max-width: 575px) {
  .labelStyle {
    .round,
    .fillet,
    .right_angle,
    .labelItemEllipsis {
      div {
        min-width: 26px !important;
        min-height: 26px !important;
      }
    }
  }
}
</style>
